import { render, staticRenderFns } from "./text.vue?vue&type=template&id=3bf05184&scoped=true"
import script from "./text.vue?vue&type=script&lang=js"
export * from "./text.vue?vue&type=script&lang=js"
import style0 from "./text.vue?vue&type=style&index=0&id=3bf05184&prod&lang=less&scoped=true"
import style1 from "./text.vue?vue&type=style&index=1&id=3bf05184&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf05184",
  null
  
)

export default component.exports